import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__customer-search';
const SEARCH_BUTTON_TEXT = '<i class="search icon"></i>';
const SEARCH_BUTTON = `<button type="button" class="ui icon button">${SEARCH_BUTTON_TEXT}</button>`;
const BUTTON_LOADER = '<div class="ui active tiny inline loader"></div>';
const ERROR_MESSAGE_SELECTOR = '.ui.red.pointing.label';
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["Enabled"] = "enabled";
    AccountStatus["Disabled"] = "disabled";
})(AccountStatus || (AccountStatus = {}));
export class CustomerSearch {
    static xhrRequest = null;
    static previousInputValue = $(ELEMENT_SELECTOR).val();
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        if (!$elements.length) {
            return;
        }
        this.initActions($elements);
    }
    static initActions($elements) {
        $elements.each((index, element) => {
            const $element = $(element);
            const $searchButton = $(SEARCH_BUTTON);
            $element.wrap('<div class="ui action input"></div>');
            $element.parent().append($searchButton);
            $searchButton.on('click', e => {
                this.handleSearch($element, $searchButton);
            });
            $element.on('keypress', e => {
                if (e.which === 13) {
                    e.preventDefault();
                    $element.trigger('blur');
                }
            });
            $element.on('change', e => {
                const value = $(e.currentTarget).val();
                if (this.previousInputValue !== value) {
                    this.previousInputValue = String(value);
                    this.handleSearch($element, $searchButton);
                }
            });
            if ($element.val()) {
                this.handleSearch($element, $searchButton);
            }
        });
    }
    static handleSearch($input, $button) {
        if (this.xhrRequest) {
            this.xhrRequest.abort();
            this.xhrRequest = null;
        }
        if (!$input.val()) {
            this.removeErrorMessages($input);
            this.removeMessages($input);
            return;
        }
        this.xhrRequest = $.ajax({
            method: 'POST',
            url: $input.data('search-url'),
            data: {
                search: $input.val(),
            },
            beforeSend: () => {
                $button.html(BUTTON_LOADER);
                this.removeErrorMessages($input);
                this.removeMessages($input);
            },
        })
            .done((data) => {
            const responseData = JSON.parse(data);
            if (responseData.accountStatus !== AccountStatus.Enabled) {
                this.showErrorMessage($input, $input.data('search-found-disabled-text'));
            }
            this.showMessage($input, responseData);
        })
            .fail(xhr => {
            if (xhr.status === 404) {
                this.showErrorMessage($input, $input.data('search-not-found-text'));
            }
        })
            .always(() => {
            $button.html(SEARCH_BUTTON_TEXT);
        });
    }
    static removeErrorMessages($input) {
        $input.parent().parent().find(ERROR_MESSAGE_SELECTOR).remove();
        $input.closest('.field').removeClass('error');
    }
    static removeMessages($input) {
        $input.parent().parent().parent().find('.js__input-with-search-message').remove();
    }
    static showErrorMessage($input, message) {
        $input.parent().parent().append(`<div class="ui red pointing label">${message}</div>`);
        $input.closest('.field').addClass('error');
    }
    static showMessage($input, data) {
        const $messagePrototype = $($input.data('search-found-text-prototype-selector'));
        const $message = $messagePrototype
            .clone()
            .removeClass('js__input-with-search-message-prototype')
            .addClass('js__input-with-search-message');
        let messageElementString = $message.prop('outerHTML');
        for (const [key, value] of Object.entries(data)) {
            messageElementString = messageElementString.replaceAll(`%${key}%`, value || '-');
        }
        $(messageElementString).insertAfter($input.parent().parent()).show();
    }
}
